
<template>

    <v-content  class="mt-2">
       <v-row>
          <v-col lg="12" sm="12">
                    <v-img height="200px" src="../assets/banner.jpg">
            </v-img>
            <v-row justify="center">
              <v-col align-self="start" class="d-flex justify-center align-center pa-0" cols="12">
                <v-avatar class="profile avatar-center-heigth" color="grey" size="164">
                  <!-- <v-btn @click="onButtonClick" class="upload-btn" x-large icon>
                    <v-icon>
                    mdi-camera
                  </v-icon>
                  </v-btn> -->
                   <!-- <input
        ref="uploader"
        class="d-none"
        type="file"
        accept="image/*"
        :change="onFileChanged"
      > -->
                  <v-img :src="api_img"></v-img>
                 
                </v-avatar>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center py-0" cols="12">
                <v-list-item color="#0000" class="profile-text-name">
                  <v-list-item-content>
                    <v-list-item-subtitle>Student Name</v-list-item-subtitle>
                    <v-list-item-title class="text-h6">
                     {{ items[0].kh_name }}
                    </v-list-item-title>
                    <!-- <v-list-item-subtitle> {{ items[0].en_ba }}</v-list-item-subtitle> -->
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="12" sm="12" class="text-center">
                <v-list-item-content class="sutitles">
                    <v-list-item-subtitle>Student ID</v-list-item-subtitle>
                  <v-list-item-title class="text-h5 mb-1">
                      {{ items[0].student_id }}
                  </v-list-item-title>
                
                </v-list-item-content>

              </v-col>
              <!-- <v-col cols="12" lg="6" sm="12" class="text-center">
                <v-list-item-content class="sutitles">
                   <v-list-item-subtitle>Date of Birth</v-list-item-subtitle>
                  <v-list-item-title class="text-h5 mb-1">
                     {{ items[0].dob }}
                  </v-list-item-title>
                 
                </v-list-item-content>
              </v-col> -->
              <!-- <v-col cols="12" lg="3" sm="12"  class="text-center">
                <v-list-item-content class="sutitles">
                  <v-list-item-title class="text-h5 mb-1">
                    10
                  </v-list-item-title>
                  <v-list-item-subtitle>Seguindo</v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <v-col cols="12"  lg="3" sm="12" class="text-center">
                <v-list-item-content class="sutitles">
                  <v-list-item-title class="text-h5 mb-1">
                    10089
                  </v-list-item-title>
                  <v-list-item-subtitle>Seguidores</v-list-item-subtitle>
                </v-list-item-content>
              </v-col> -->
            </v-row>
          
          </v-col>
       </v-row>
    </v-content>
</template>

<script>
import axios from 'axios'
  export default {
    
    name: 'account-student',
    data:()=>({
          drawers: true,
          items: [],
           drawer: false,
           group: null,
           api_img:''
           
    }),
    methods:
    {

        setClassID(class_id){
             window.localStorage.setItem('class_id' ,class_id)

             this.$router.push({ name: "view-score" });
        },
               Logout(){   

                
              localStorage.removeItem('hasLogin')
              this.$router.push({ name: "login" });
        }

    },

    created (){

       this.items = JSON.parse(localStorage.getItem("info"))
        axios.get('http://api.isbbcambodia.org/API_ELITE/fetch_student.php?id='+this.items.student_id).then((data)=>{

         window.localStorage.setItem('class_info' ,JSON.stringify(data.data))


              this.items=data.data.data
              this.api_img = "http://api.isbbcambodia.org/isbb/public/uploads/photo/"+this.items[0].photo
           

        }).catch((error)=>{

       })
    }
  }
</script>
<style>
.upload-btn{
  position: absolute !important;
    z-index: 999;
    top: 121px;
    color: cadetblue;
    background: blueviolet;
    background: rgb(125,198,163);                                                                                                                                                                                                                                                                                                                                                                                                                                                                
    background: linear-gradient(50deg, rgba(125,198,163,1) 0%, rgba(35,216,227,1) 72%);
}
</style>  